import { createContext } from 'react';
import type { UnifiedPermissionsContextValue } from './types';

export const UnifiedPermissionsContext = createContext<
  UnifiedPermissionsContextValue | undefined
>(undefined);
